import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { HostListener } from '@angular/core';
import { ICompany } from '@app/core/interfaces/ICompany';
import { IContact } from '@app/core/interfaces/IContact';
import { ITimeReportStatus } from '@app/core/interfaces/invoice/TimeReportStatus';
import { CanComponentDeactivate } from '@app/core/guards/CanDeactivate.Component';
import { CompanyService } from '@app/core/services/CompanyService';
import { InvoiceService } from '@app/core/services/InvoiceService';
import { AuthenticationService } from '@app/core/services/AuthenticationService';
import { UserService } from '@app/core/services/UserService';
import { EditCustomerDialogComponent } from '../../shared/customer/EditCustomerDialog.Component';
import { EditContactDialogComponent } from '../../shared/contact/EditContactDialog.Component';
import { InvoiceToolCalendarDialogComponent } from '../invoice-tool/invoice-tool.calendarDialog.Component';

const JOB_PRE_NOTIFICATION_STATUS = 'Draft';
const JOB_PRE_NOTIFICATION_STATUS_NAME = 'Utkast';
const SINGLE_INVOICE_TYPE = 'SingleInvoice';
const INVOICE_ITEM_GROUP_TYPE = 'InvoiceItem';
const WORKED_HOURS_GROUP_TYPE = 'WorkedHours';
const WORK_NOTICE_STATUS_PRE_NOTIFIED = 'PreNotified';

@Component({
  standalone: false,
  selector: 'app-job-pre-notification',
  templateUrl: './job-pre-notification.component.html',
  styleUrls: ['./job-pre-notification.component.scss']
})
export class JobPreNotificationComponent implements OnInit, CanComponentDeactivate {
  ref: IContact = {
    Id: 0,
    Name: '',
    NameLocked: false,
    Phone: '',
    Email: '',
    Address: '',
    Zip: '',
    City: '',
    IDNumber: ''
  };

  invoice: any = {
    Id: 0,
    Allowances: [],
    DiscountCodes: [],
    ReferenceText: null,
    InvoiceFee: 0,
    ExpressPayOut: false,
    RotDrivingFee: 3,
    RotDrivingFeeTotalAmount: 0,
    IsRot: false,
    IsRut: false,
    IsRotRut: false,
    RotProperty: null,
    RotDrivingFeeKm: 0,
    Marking: '',
    RecieverEmailCopy: '',
    RecieverEmailReminder: '',
    WorkCountry: 'Sverige',
    CreditInvoiceFor: null,
    ExpressPayout: false,
    Status: {
      TechnicalName: JOB_PRE_NOTIFICATION_STATUS,
      Name: JOB_PRE_NOTIFICATION_STATUS_NAME,
      Order: 0
    },
    User: { Id: '0' },
    InvoiceGroups: [],
    Messages: [],
    Message: undefined,
    TravelExpenses: { Reciepts: [], TravelReportTotalAmount: 0, DriveJournalTotalAmount: 0 },
    PaymentTerm: '30',
    SalaryShares: [],
    selectedReference: '',
    ShowDeductions: false,
    ShowMileDeduction: false,
    TravelDistance: undefined,
    Deductions: [],
    invoiceItemGroup: [],
    Reference: this.ref,
    RecieverEmail: '',
    termsAgreed: false,
    Customer: {
      Id: 0,
      Active: true,
      Name: '',
      OrgNumber: '',
      AcceptsInvoiceFee: true,
      TimeReportMandatory: false,
      NameLocked: false,
      AcceptsInvoiceFeeLocked: false,
      Address: '',
      AddressLocked: false,
      Zip: '',
      ZipLocked: false,
      City: '',
      CityLocked: false,
      ElectronicReference: '',
      ElectronicReferenceMandatory: false,
      GlnNumber: null,
      GlnNumberLocked: false,
      Country: { Id: 1, Name: 'Sverige', Eu: true },
      Reference: {},
      InvoiceEmail: '',
      InvoiceEmailLocked: false,
      InvoiceSendType: 1,
      PaymentTerm: 30,
      PaymentTermLocked: false,
      InvoiceSendTypeLocked: false,
      Contacts: [],
      IsCompany: true,
      PublicInfo: ''
    },
    Currency: { Id: '1', Name: 'SEK' },
    InvoiceSendMethodEmail: true,
    InvoiceSendMethodMail: false,
    InvoiceSendType: 1,
    action: '',
    RecieverCompanyName: '',
    RecieverAddress1: '',
    RecieverZip: '',
    RecieverCity: '',
    SelectedCurrency: 'SEK',
    SubInvoices: [],
    FeePaidByReciever: true,
    TotalInvoiceAmount: 0,
    SubInvoice: false,
    PensionSavingsAmount: 0,
    PensionSavingsFactor: 0,
    Documents: [],
    ReverseTax: false,
    Type: { Name: '', TechnicalName: SINGLE_INVOICE_TYPE },
    UserSettings: {
      Id: '',
      AccountNumber: 0,
      PensionSavingsSettings: {
        Id: 0,
        Amount: 0,
        Unit: { Id: 0, TechnicalName: '' },
        PensionSavingsCompany: { TechnicalName: '' }
      }
    },
    PayoutDate: undefined,
    CustomerCopy: {
      Id: 0,
      Active: true,
      Name: '',
      OrgNumber: '',
      AcceptsInvoiceFee: true,
      TimeReportMandatory: false,
      NameLocked: false,
      AcceptsInvoiceFeeLocked: false,
      Address: '',
      AddressLocked: false,
      Zip: '',
      ZipLocked: false,
      City: '',
      CityLocked: false,
      ElectronicReference: '',
      ElectronicReferenceMandatory: false,
      GlnNumber: null,
      GlnNumberLocked: false,
      Country: { Id: null, Name: null },
      Reference: {},
      InvoiceEmail: '',
      InvoiceEmailLocked: false,
      InvoiceSendType: 0,
      PaymentTerm: 0,
      PaymentTermLocked: false,
      InvoiceSendTypeLocked: false,
      Contacts: [],
      IsCompany: false,
      PublicInfo: ''
    }
  };

  pendingGroupTemplate: any = {
    Id: '',
    Description: '',
    Vat: '25',
    VatNoSwe: '0',
    ReverseTax: false,
    TimeReportStatus: { DisplayName: 'Ingen tid', Id: '3', Name: 'NoInfo' },
    PaymentReciever: { Id: '', Name: null, PersonalNumber: null, OrgNumber: null, IsCompany: false, LastLogin: null, User: null },
    Type: { Value: '1', Name: 'Arbetad tid' },
    rowTypeSelected: '1',
    InvoiceRows: [],
    Amount: 0,
    WorkingTitle: '',
    VatAmount: 0
  };

  pendingRowDefaultHours = '8';
  pendingRowDefaultMinutes = '0';
  hoursOptions: string[] = Array.from({ length: 25 }, (_, index) => index.toString());
  minuteOptions: string[] = ['0', '15', '30', '45'];
  timeReportStatuses: ITimeReportStatus[] = [];
  pendingGroupEditingId: string | null = null;
  pendingCalendarDate: Date = new Date();
  editingInvoiceId: number | null = null;
  isEditingDescription = false;
  editingDescriptionId: string | null = null;

  pendingGroup = this.clonePendingGroup();
  companies: ICompany[] = [];
  contacts: IContact[] = [];
  countries: any[] = [];
  selectedCustomer: ICompany | null = null;
  workedHoursGroup: any | null = null;
  isEditingWorkedHours = false;
  hoursWorkedTotal = 0;
  totalDays = 0;
  totalAmount = 0;
  pendingError = '';
  saveError = '';
  isSaving = false;
  isAdmin = false;
  private savedViewSnapshot = '';

  customerDialogConfig: any = {
    disableClose: false,
    panelClass: 'full-screen-modal',
    hasBackdrop: true,
    backdropClass: '',
    width: '500px',
    maxWidth: '98vw',
    height: '80%'
  };

  calendarDialogConfig: any = {
    disableClose: false,
    panelClass: 'full-screen-modal',
    hasBackdrop: true,
    backdropClass: '',
    width: '600px',
    maxWidth: '98vw',
    height: '90vh',
    maxHeight: '90vh',
    position: { top: '-45px' }
  };

  constructor(
    private companyService: CompanyService,
    private invoiceService: InvoiceService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isAdmin = this.userService.userHasRole('admin');
    const currentUser = this.authenticationService.userData && this.authenticationService.userData.User
      ? this.authenticationService.userData.User
      : null;
    if (currentUser) {
      this.invoice.User.Id = currentUser.Id;
      this.invoice.UserSettings = currentUser;
    }
    this.getCompanies();
    this.loadTimeReportStatuses();
    this.loadCountries();
    this.checkForInvoiceToEdit();
    this.updateSavedViewSnapshot();
  }

  getCompanies(): void {
    if (this.invoice.UserSettings && this.invoice.UserSettings.Id && (this.isAdmin || this.invoice.UserSettings.Id !== '')) {
      this.companyService
        .getCompanies(this.invoice.UserSettings.Id, true)
        .subscribe(value => this.onGetCompaniesFinished(value), () => {});
    } else {
      this.companyService
        .getMyCompanies()
        .subscribe(value => this.onGetCompaniesFinished(value), () => {});
    }
  }

  private loadTimeReportStatuses(): void {
    this.invoiceService.getTimeReportStatuses().subscribe(
      statuses => this.onTimeReportStatusesLoaded(statuses),
      () => {}
    );
  }

  private checkForInvoiceToEdit(): void {
    const invoiceIdParam = this.route.snapshot.queryParamMap.get('invoiceId');
    const parsedId = invoiceIdParam ? parseInt(invoiceIdParam, 10) : NaN;

    if (!isNaN(parsedId) && parsedId > 0) {
      this.editingInvoiceId = parsedId;
      this.loadInvoiceForEdit(parsedId);
    }
  }

  private onTimeReportStatusesLoaded(statuses: ITimeReportStatus[]): void {
    this.timeReportStatuses = statuses || [];
    this.applyTimeReportStatusRules();
  }

  private loadCountries(): void {
    this.companyService.getCountries().subscribe(
      response => {
        const nextCountries = response || [];
        setTimeout(() => {
          this.countries = nextCountries;
          if (!this.invoice.WorkCountry && this.countries.some(country => country && country.Name === 'Sverige')) {
            this.invoice.WorkCountry = 'Sverige';
          }
        }, 0);
      },
      () => {
        setTimeout(() => {
          this.countries = [];
        }, 0);
      }
    );
  }

  private loadInvoiceForEdit(invoiceId: number): void {
    this.invoiceService.getJobPreNotification(invoiceId).subscribe(
      invoiceData => this.onInvoiceLoadedForEdit(invoiceData),
      () => {}
    );
  }

  private onInvoiceLoadedForEdit(invoiceData: any): void {
    if (!invoiceData) {
      return;
    }

    const preparedInvoice = {
      ...this.invoice,
      ...invoiceData
    };

    preparedInvoice.User = invoiceData.User || preparedInvoice.User;
    preparedInvoice.UserSettings = invoiceData.UserSettings || invoiceData.User || preparedInvoice.UserSettings;

    preparedInvoice.InvoiceGroups = Array.isArray(invoiceData.InvoiceGroups) ? invoiceData.InvoiceGroups : [];
    preparedInvoice.Deductions = Array.isArray(invoiceData.Deductions) ? invoiceData.Deductions : [];
    preparedInvoice.Allowances = Array.isArray(invoiceData.Allowances) ? invoiceData.Allowances : [];
    preparedInvoice.Customer = invoiceData.Customer || this.invoice.Customer;
    preparedInvoice.CustomerCopy = invoiceData.CustomerCopy || preparedInvoice.Customer || this.invoice.CustomerCopy;
    preparedInvoice.Reference = invoiceData.Reference ? { ...invoiceData.Reference } : { ...this.ref };
    preparedInvoice.PaymentTerm = preparedInvoice.PaymentTerm ? preparedInvoice.PaymentTerm.toString() : '30';
    preparedInvoice.InvoiceSendType =
      preparedInvoice.InvoiceSendType && preparedInvoice.InvoiceSendType > 0 ? preparedInvoice.InvoiceSendType : 1;
    preparedInvoice.RecieverEmail = preparedInvoice.RecieverEmail || (preparedInvoice.Customer ? preparedInvoice.Customer.InvoiceEmail : '');

    this.invoice = preparedInvoice;
    this.splitInvoiceGroupsForEdit(preparedInvoice.InvoiceGroups);
    this.selectedCustomer = this.invoice.Customer || null;
    if (this.invoice.Customer) {
      this.ensureCustomerCountry(this.invoice.Customer);
      this.setRecieverAddress();
      if (this.invoice.Customer.Id) {
        this.getCompanyContacts(this.invoice.Customer.Id);
      }
    }
    this.ensureSelectedCustomerInList();
    this.applyTimeReportStatusRules();
    this.updateTotals();
    this.updateSavedViewSnapshot();
    if (this.invoice.Customer && this.invoice.Customer.Id) {
      this.getCompanyContacts(this.invoice.Customer.Id);
    }
    this.getCompanies();
  }

  canDeactivate(): boolean {
    return this.confirmNavigationIfNeeded();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (!this.hasUnsavedChanges()) {
      return;
    }

    event.preventDefault();
    event.returnValue = '';
  }

  private ensureSelectedCustomerInList(): void {
    if (this.selectedCustomer && !this.companies.some(company => company.Id === this.selectedCustomer.Id)) {
      this.companies = [...this.companies, this.selectedCustomer];
    }
  }

  private onGetCompaniesFinished(companies: ICompany[]): void {
    this.companies = companies || [];
    if (!this.isAdmin) {
      this.companies = this.companies.filter(c => c.ActiveInList !== false);
    }
    this.ensureSelectedCustomerInList();
  }

  customerChange(customerId: number): void {
    if (!customerId) {
      this.selectedCustomer = null;
      this.invoice.Customer.Id = 0;
      this.contacts = [];
      this.invoice.Reference = { ...this.ref };
      this.invoice.CustomerCopy = {
        Id: 0,
        Active: true,
        Name: '',
        OrgNumber: '',
        AcceptsInvoiceFee: true,
        TimeReportMandatory: false,
        NameLocked: false,
        AcceptsInvoiceFeeLocked: false,
        Address: '',
        AddressLocked: false,
        Zip: '',
        ZipLocked: false,
        City: '',
        CityLocked: false,
        ElectronicReference: '',
        ElectronicReferenceMandatory: false,
        GlnNumber: null,
        GlnNumberLocked: false,
        Country: { Id: null, Name: null },
        Reference: {},
        InvoiceEmail: '',
        InvoiceEmailLocked: false,
        InvoiceSendType: 0,
        PaymentTerm: 0,
        PaymentTermLocked: false,
        InvoiceSendTypeLocked: false,
        Contacts: [],
        IsCompany: false,
        PublicInfo: ''
      };
      return;
    }

    const customer = this.companies.find(c => c.Id === customerId);
    if (!customer) {
      return;
    }

    this.selectedCustomer = customer;
    this.invoice.Customer = JSON.parse(JSON.stringify(customer));
    this.invoice.CustomerCopy = JSON.parse(JSON.stringify(customer));
    this.ensureCustomerCountry(this.invoice.Customer);
    this.invoice.InvoiceSendType = customer.InvoiceSendType && customer.InvoiceSendType > 0 ? customer.InvoiceSendType : 1;
    this.invoice.PaymentTerm = customer.PaymentTerm ? customer.PaymentTerm.toString() : '30';
    this.invoice.RecieverEmail = customer.InvoiceEmail || '';
    this.invoice.Reference = { ...this.ref };
    this.setRecieverAddress();
    this.getCompanyContacts(customer.Id);
    this.applyTimeReportStatusRules();
  }

  private ensureCustomerCountry(customer: ICompany): void {
    if (!customer.Country) {
      customer.Country = { Id: 1, Name: 'Sverige', Eu: true } as any;
    } else if (!customer.Country.Name) {
      customer.Country.Name = 'Sverige';
    }
  }

  private setRecieverAddress(): void {
    this.invoice.RecieverCompanyName = this.invoice.Customer.Name;
    this.invoice.RecieverAddress1 = this.invoice.Customer.Address;
    this.invoice.RecieverZip = this.invoice.Customer.Zip;
    this.invoice.RecieverCity = this.invoice.Customer.City;
  }

  getCompanyContacts(companyId: number): void {
    this.companyService
      .getCompanyContacts(companyId)
      .subscribe(response => (this.contacts = response || []), () => (this.contacts = []));
  }

  contactChange(contactId: number): void {
    if (!contactId) {
      this.invoice.Reference = { ...this.ref };
      return;
    }

    const contact = this.contacts.find(c => c.Id === contactId);
    if (contact) {
      this.invoice.Reference = {
        Id: contact.Id,
        Name: contact.Name,
        NameLocked: contact.NameLocked,
        Phone: contact.Phone,
        Email: contact.Email,
        Address: contact.Address,
        Zip: contact.Zip,
        City: contact.City,
        IDNumber: contact.IDNumber
      };
    }
  }

  addCustomer(): void {
    const data = {
      customerTemplate: {
        Id: 0,
        User: { Id: this.invoice.User.Id },
        Country: { Id: 1, Name: 'Sverige' },
        IsCompany: true
      }
    };

    const dialogRef = this.dialog.open(EditCustomerDialogComponent, {
      ...this.customerDialogConfig,
      data
    });

    dialogRef.afterClosed().subscribe((result: ICompany) => {
      if (result) {
        this.companies.push(result);
        this.customerChange(result.Id);
      }
    });
  }

  editCustomer(): void {
    if (!(this.invoice.Customer && this.invoice.Customer.Id)) {
      return;
    }

    const dialogRef = this.dialog.open(EditCustomerDialogComponent, {
      ...this.customerDialogConfig,
      data: { customer: this.invoice.Customer }
    });

    dialogRef.afterClosed().subscribe((updated: ICompany) => {
      if (updated) {
        this.updateCustomerInList(updated);
        this.customerChange(updated.Id);
      }
    });
  }

  private updateCustomerInList(company: ICompany): void {
    this.companies = this.companies.map(existing => (existing.Id === company.Id ? company : existing));
    if (this.invoice.Customer && this.invoice.Customer.Id === company.Id) {
      this.invoice.Customer = JSON.parse(JSON.stringify(company));
      this.invoice.CustomerCopy = JSON.parse(JSON.stringify(company));
      this.ensureCustomerCountry(this.invoice.Customer);
      this.setRecieverAddress();
    }
  }

  addContact(): void {
    if (!(this.invoice.Customer && this.invoice.Customer.Id && this.invoice.Customer.IsCompany)) {
      return;
    }

    const dialogRef = this.dialog.open(EditContactDialogComponent, {
      ...this.customerDialogConfig,
      data: { contact: <IContact>{}, companyId: this.invoice.Customer.Id }
    });

    dialogRef.afterClosed().subscribe((result: IContact) => {
      if (result) {
        this.addSavedContact(result);
      }
    });
  }

  editContact(contact: IContact): void {
    if (!contact || !(this.invoice.Customer && this.invoice.Customer.Id && this.invoice.Customer.IsCompany)) {
      return;
    }

    const dialogRef = this.dialog.open(EditContactDialogComponent, {
      ...this.customerDialogConfig,
      data: { contact, companyId: this.invoice.Customer.Id }
    });

    dialogRef.afterClosed().subscribe((result: IContact) => {
      if (result) {
        this.contacts = this.contacts.map(existing => (existing.Id === result.Id ? result : existing));
        this.invoice.Reference = { ...result };
      }
    });
  }

  private addSavedContact(contact: IContact): void {
    this.contacts.push(contact);
    this.invoice.Reference = { ...contact };
  }

  openPendingCalendar(): void {
    if (!this.canSubmitPendingGroup()) {
      return;
    }

    const timeGroup = this.preparePendingGroupForSave();
    if (this.workedHoursGroup && this.workedHoursGroup.Id) {
      timeGroup.Id = this.workedHoursGroup.Id;
    }
    this.workedHoursGroup = timeGroup;

    this.resetPendingGroup();
    this.updateTotals();
  }

  editCalendar(group: any): void {
    if (!group) {
      return;
    }

    const data = {
      invoiceItemGroup: JSON.parse(JSON.stringify(group)),
      customer: { TimeReportMandatory: this.invoice.Customer && this.invoice.Customer.TimeReportMandatory === true },
      status: this.invoice.Status && this.invoice.Status.TechnicalName ? this.invoice.Status.TechnicalName : JOB_PRE_NOTIFICATION_STATUS,
      customerCountryName: this.invoice.Customer && this.invoice.Customer.Country ? this.invoice.Customer.Country.Name : 'Sverige',
      workCountry: this.toWorkCountryName(this.invoice.WorkCountry) || 'Sverige',
      isRotRut: !!(this.invoice.IsRotRut || this.invoice.IsRot || this.invoice.IsRut),
      invoiceCurrencyName: this.invoice.Currency ? this.invoice.Currency.Name : 'SEK'
    };

    const dialogRef = this.dialog.open(InvoiceToolCalendarDialogComponent, {
      ...this.calendarDialogConfig,
      data
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) {
        return;
      }

      const resultWorkCountry = this.toWorkCountryName(result.WorkCountry).trim();
      if (resultWorkCountry !== '') {
        this.invoice.WorkCountry = resultWorkCountry;
      }

      if (result.action === 'delete') {
        this.invoice.InvoiceGroups = this.invoice.InvoiceGroups.filter(g => g.Id !== result.Id);
      } else {
        const index = this.invoice.InvoiceGroups.findIndex(g => g.Id === result.Id);
        if (index > -1) {
          this.invoice.InvoiceGroups[index] = result;
        } else {
          this.invoice.InvoiceGroups.push(result);
        }
      }

      this.updateTotals();
    });
  }

  deleteGroup(group: any): void {
    this.invoice.InvoiceGroups = this.invoice.InvoiceGroups.filter(g => g.Id !== group.Id);
    if (this.isEditingDescription && this.editingDescriptionId === group.Id) {
      this.resetDescriptionEditing();
    }
    this.updateTotals();
  }

  deleteWorkedHoursGroup(): void {
    this.workedHoursGroup = null;
    if (this.isEditingWorkedHours) {
      this.resetPendingGroup();
    }
    this.updateTotals();
  }

  editWorkedHoursGroup(): void {
    if (!this.workedHoursGroup) {
      return;
    }

    this.pendingGroup = this.normalizePendingGroup(this.workedHoursGroup);
    this.pendingGroup.Description = '';
    this.pendingGroupEditingId = this.workedHoursGroup.Id;
    this.isEditingWorkedHours = true;
  }

  editDescriptionGroup(group: any): void {
    if (!group) {
      return;
    }

    this.pendingGroup.Description = group.Description || '';
    this.editingDescriptionId = group.Id;
    this.isEditingDescription = true;
    this.pendingError = '';
  }

  saveDescriptionGroup(): void {
    if (!this.canSubmitDescriptionGroup()) {
      return;
    }

    if (this.isEditingDescription && this.editingDescriptionId) {
      const index = this.invoice.InvoiceGroups.findIndex(g => g.Id === this.editingDescriptionId);
      if (index > -1) {
        this.invoice.InvoiceGroups[index] = {
          ...this.invoice.InvoiceGroups[index],
          Description: this.pendingGroup.Description
        };
      }
    } else {
      const descriptionGroup = this.createDescriptionGroupFromPending();
      this.invoice.InvoiceGroups.push(descriptionGroup);
    }

    this.resetDescriptionEditing();
    this.updateTotals();
  }

  deleteEditingDescription(): void {
    if (!this.isEditingDescription || !this.editingDescriptionId) {
      return;
    }

    const shouldDelete = window.confirm('Vill du verkligen radera beskrivningen?');
    if (!shouldDelete) {
      return;
    }

    this.invoice.InvoiceGroups = this.invoice.InvoiceGroups.filter(g => g.Id !== this.editingDescriptionId);
    this.resetDescriptionEditing();
    this.updateTotals();
  }

  cancelDescriptionEditing(): void {
    this.resetDescriptionEditing();
  }

  canAddInvoiceItem(): boolean {
    return !this.invoice?.InvoiceGroups || this.invoice.InvoiceGroups.length === 0;
  }

  private resetDescriptionEditing(): void {
    this.pendingGroup.Description = '';
    this.editingDescriptionId = null;
    this.isEditingDescription = false;
    this.pendingError = '';
  }

  cancelWorkedHoursEditing(): void {
    if (this.workedHoursGroup) {
      this.pendingGroup = this.normalizePendingGroup(this.workedHoursGroup);
      this.pendingGroup.Description = '';
      this.pendingGroupEditingId = this.workedHoursGroup.Id;
    } else {
      this.pendingGroup = this.clonePendingGroup();
      this.pendingGroupEditingId = null;
    }

    this.isEditingWorkedHours = false;
    this.pendingError = '';
    this.applyTimeReportStatusRules();
  }

  private resetPendingGroup(): void {
    this.pendingGroup = this.clonePendingGroup();
    this.pendingGroupEditingId = null;
    this.pendingError = '';
    this.isEditingWorkedHours = false;
    this.isEditingDescription = false;
    this.editingDescriptionId = null;
    this.applyTimeReportStatusRules();
  }

  private clonePendingGroup(): any {
    return this.normalizePendingGroup(this.pendingGroupTemplate);
  }

  onCalendarDateSelected(date: Date | null): void {
    if (!date) {
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      this.pendingError = 'Du kan bara lägga till datum från och med idag.';
      return;
    }

    this.pendingError = '';
    this.pendingCalendarDate = date;
    const formatted = this.formatDate(date);
    if (!formatted) {
      return;
    }

    if (!Array.isArray(this.pendingGroup.InvoiceRows)) {
      this.pendingGroup.InvoiceRows = [];
    }

    const exists = this.pendingGroup.InvoiceRows.some(row => row.StartDate === formatted);
    if (exists) {
      return;
    }

    this.pendingGroup.InvoiceRows.push({
      StartDate: formatted,
      Id: this.guid(),
      HoursWorked: this.pendingRowDefaultHours,
      MinutesWorked: this.pendingRowDefaultMinutes
    });
    this.sortPendingRows();
  }

  removePendingRow(rowId: string): void {
    if (!Array.isArray(this.pendingGroup.InvoiceRows)) {
      return;
    }

    const row = this.pendingGroup.InvoiceRows.find(r => r.Id === rowId);
    if (row && this.isRowInPast(row)) {
      this.pendingError = 'Du kan bara ta bort datum fr\u00e5n och med idag.';
      return;
    }

    this.pendingGroup.InvoiceRows = this.pendingGroup.InvoiceRows.filter(row => row.Id !== rowId);
  }


  private preparePendingGroupForSave(): any {
    const group = this.normalizePendingGroup(this.pendingGroup);
    group.Id = this.pendingGroupEditingId || group.Id || this.guid();

    if (group.TimeReportStatus && group.TimeReportStatus.Id != null && this.timeReportStatuses && this.timeReportStatuses.length) {
      const status = this.timeReportStatuses.find(item => item.Id.toString() === group.TimeReportStatus.Id.toString());
      if (status) {
        group.TimeReportStatus = {
          Id: status.Id.toString(),
          Name: status.Name,
          DisplayName: status.DisplayName
        };
      }
    }

    return group;
  }

  private canSubmitPendingGroup(): boolean {
    if (!(this.invoice.Customer && this.invoice.Customer.Id)) {
      this.pendingError = 'V\u00e4lj en kund innan du l\u00e4gger till arbetad tid.';
      return false;
    }

    if (!this.pendingGroup.WorkingTitle || !this.pendingGroup.WorkingTitle.trim()) {
      this.pendingError = 'Befattning/titel/yrke m\u00e5ste anges.';
      return false;
    }

    if (this.isTimeInfoOptionSelected() && this.isPendingGroupInvoiceRowsEmpty()) {
      this.pendingError = 'V\u00e4lj datum och tid f\u00f6r att visa p\u00e5 faktura.';
      return false;
    }

    if (this.isPendingGroupInvoiceRowsEmpty()) {
      this.pendingError = 'L\u00e4gg till minst ett datum innan du sparar.';
      return false;
    }

    this.pendingError = '';
    return true;
  }

  private canSubmitDescriptionGroup(): boolean {
    if (!(this.invoice.Customer && this.invoice.Customer.Id)) {
      this.pendingError = 'V\u00e4lj en kund innan du l\u00e4gger till en beskrivning.';
      return false;
    }

    if (!this.canAddInvoiceItem()) {
      if (!this.isEditingDescription) {
        this.pendingError = 'Det g\u00e5r inte att l\u00e4gga till fler beskrivningar.';
        return false;
      }
    }

    if (!this.pendingGroup.Description || !this.pendingGroup.Description.trim()) {
      this.pendingError = 'Ange en beskrivning av arbetet.';
      return false;
    }

    if (!this.isDescriptionAllowed(this.pendingGroup.Description || '')) {
      this.pendingError =
        'Beskrivningen inneh\u00e5ller otill\u00e5tna tecken. Du beh\u00f6ver radera otill\u00e5tna tecken och tabbar. Godk\u00e4nt inneh\u00e5ll \u00e4r a-\u00f6, A-\u00d6, 0-9 samt , . ! ( ) ? / -';
      return false;
    }

    this.pendingError = '';
    return true;
  }

  private createDescriptionGroupFromPending(): any {
    const descriptionGroup = this.normalizePendingGroup(this.pendingGroup);
    descriptionGroup.Id = this.guid();
    descriptionGroup.InvoiceRows = [];
    descriptionGroup.WorkingTitle = '';
    return descriptionGroup;
  }

  private splitInvoiceGroupsForEdit(groups: any[]): void {
    const descriptionGroups: any[] = [];
    let workedHours: any | null = null;

    (groups || []).forEach(group => {
      const typeName = group && group.Type ? group.Type.TechnicalName : '';
      const hasRows = group && Array.isArray(group.InvoiceRows) && group.InvoiceRows.length > 0;
      if (typeName === WORKED_HOURS_GROUP_TYPE || (!typeName && hasRows)) {
        if (!workedHours) {
          workedHours = this.normalizePendingGroup(group);
        }
        return;
      }

      if (typeName === INVOICE_ITEM_GROUP_TYPE) {
        const descriptionGroup = { ...group, InvoiceRows: [], WorkingTitle: '' };
        descriptionGroups.push(descriptionGroup);
        return;
      }

      if (group && group.Description) {
        const descriptionGroup = { ...group, InvoiceRows: [], WorkingTitle: '' };
        descriptionGroups.push(descriptionGroup);
      }
    });

    this.workedHoursGroup = workedHours;
    this.invoice.InvoiceGroups = descriptionGroups;
    if (this.workedHoursGroup) {
      this.pendingGroup = this.normalizePendingGroup(this.workedHoursGroup);
      this.pendingGroup.Description = '';
      this.pendingGroupEditingId = this.workedHoursGroup.Id;
    }
  }

  private normalizePendingGroup(source: any): any {
    const clone = JSON.parse(JSON.stringify(source));
    clone.Id = clone.Id || '';
    clone.InvoiceRows = Array.isArray(clone.InvoiceRows)
      ? clone.InvoiceRows.map(row => ({
          ...row,
          HoursWorked:
            row.HoursWorked !== undefined && row.HoursWorked !== null ? row.HoursWorked.toString() : this.pendingRowDefaultHours,
          MinutesWorked:
            row.MinutesWorked !== undefined && row.MinutesWorked !== null
              ? row.MinutesWorked.toString()
              : this.pendingRowDefaultMinutes
        }))
      : [];

    if (!clone.TimeReportStatus) {
      clone.TimeReportStatus = { DisplayName: 'Ingen tid', Id: '3', Name: 'NoInfo' };
    } else if (clone.TimeReportStatus.Id != null) {
      clone.TimeReportStatus.Id = clone.TimeReportStatus.Id.toString();
    }

    return clone;
  }

  private applyTimeReportStatusRules(): void {
    if (!this.pendingGroup) {
      return;
    }

    if (!this.pendingGroup.TimeReportStatus) {
      this.pendingGroup.TimeReportStatus = { DisplayName: 'Ingen tid', Id: '3', Name: 'NoInfo' };
    }

    if (!this.timeReportStatuses || !this.timeReportStatuses.length) {
      if (this.pendingGroup.TimeReportStatus.Id != null) {
        this.pendingGroup.TimeReportStatus.Id = this.pendingGroup.TimeReportStatus.Id.toString();
      }
      return;
    }

    if (this.requiresDetailedTimeInfo()) {
      const detailed = this.timeReportStatuses.find(status => status.Name === 'DetailedInfo');
      if (detailed) {
        this.pendingGroup.TimeReportStatus = {
          Id: detailed.Id.toString(),
          Name: detailed.Name,
          DisplayName: detailed.DisplayName
        };
      }
      return;
    }

    if (!this.pendingGroup.TimeReportStatus.Id) {
      const defaultStatus =
        this.timeReportStatuses.find(status => status.SortOrder === 1) || this.timeReportStatuses[0];
      if (defaultStatus) {
        this.pendingGroup.TimeReportStatus = {
          Id: defaultStatus.Id.toString(),
          Name: defaultStatus.Name,
          DisplayName: defaultStatus.DisplayName
        };
      }
    } else {
      const existing = this.timeReportStatuses.find(
        status => status.Id.toString() === this.pendingGroup.TimeReportStatus.Id.toString()
      );
      if (existing) {
        this.pendingGroup.TimeReportStatus = {
          Id: existing.Id.toString(),
          Name: existing.Name,
          DisplayName: existing.DisplayName
        };
      } else {
        this.pendingGroup.TimeReportStatus.Id = this.pendingGroup.TimeReportStatus.Id.toString();
      }
    }
  }

  private requiresDetailedTimeInfo(): boolean {
    return (
      (this.invoice.Customer && this.invoice.Customer.TimeReportMandatory === true) ||
      !!this.invoice.IsRotRut ||
      !!this.invoice.IsRot ||
      !!this.invoice.IsRut
    );
  }

  private isTimeInfoOptionSelected(): boolean {
    const name = this.pendingGroup.TimeReportStatus ? this.pendingGroup.TimeReportStatus.Name : '';
    return name === 'DetailedInfo' || name === 'SumTime';
  }

  private isPendingGroupInvoiceRowsEmpty(): boolean {
    return !Array.isArray(this.pendingGroup.InvoiceRows) || this.pendingGroup.InvoiceRows.length === 0;
  }

  private isDescriptionAllowed(description: string): boolean {
    if (!description) {
      return true;
    }

    const regex = /^[-a-zA-ZåäöÅÄÖ0-9,./&'%+:@!?()= \\r\\n]*[^|?]$/g;
    return regex.test(description);
  }

  private toWorkCountryName(value: any): string {
    if (value == null) {
      return '';
    }

    if (typeof value === 'string') {
      return value;
    }

    if (typeof value === 'object' && typeof value.Name === 'string') {
      return value.Name;
    }

    return String(value);
  }

  private formatDate(date: Date | string | null): string {
    if (!date) {
      return '';
    }

    const value = typeof date === 'string' ? new Date(date) : date;
    if (!value || isNaN(value.getTime())) {
      return '';
    }

    const year = value.getFullYear();
    const month = `${value.getMonth() + 1}`.padStart(2, '0');
    const day = `${value.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private isRowInPast(row: any): boolean {
    if (!row || !row.StartDate) {
      return false;
    }

    const rowDate = new Date(row.StartDate);
    if (isNaN(rowDate.getTime())) {
      return false;
    }

    rowDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return rowDate < today;
  }

  isPreNotifiedRow(row: any): boolean {
    if (!row) {
      return false;
    }

    const preNotifiedFlag = row.IsPreNotified ?? row.isPreNotified;
    if (preNotifiedFlag === true || preNotifiedFlag === 1 || preNotifiedFlag === '1') {
      return true;
    }

    return !!(row.PreNotifiedAt || row.preNotifiedAt);
  }

  private sortPendingRows(): void {
    if (!Array.isArray(this.pendingGroup.InvoiceRows)) {
      return;
    }

    this.pendingGroup.InvoiceRows.sort((a: any, b: any) => {
      const dateA = new Date(a.StartDate).getTime();
      const dateB = new Date(b.StartDate).getTime();
      return dateA - dateB;
    });
  }

  private updateTotals(): void {
    this.totalAmount = this.invoice.InvoiceGroups.reduce((sum, group) => sum + (Number(group.Amount) || 0), 0);
    this.hoursWorkedTotal = 0;
    this.totalDays = 0;

    if (this.workedHoursGroup && this.workedHoursGroup.InvoiceRows) {
      const uniqueDays = new Set<string>();
      this.workedHoursGroup.InvoiceRows.forEach((row: any) => {
        const hours = parseFloat(row.HoursWorked || 0);
        const minutes = parseFloat(row.MinutesWorked || 0);
        this.hoursWorkedTotal += hours + minutes / 60;
        if (row.StartDate) {
          uniqueDays.add(this.formatDate(row.StartDate));
        }
      });
      this.totalDays = uniqueDays.size;
    }
  }

  hasPendingDescriptionDraft(): boolean {
    return this.isEditingDescription || !!(this.pendingGroup?.Description && this.pendingGroup.Description.trim());
  }

  hasPendingWorkedHoursDraft(): boolean {
    const hasPendingTitle = !!(this.pendingGroup?.WorkingTitle && this.pendingGroup.WorkingTitle.trim());
    const hasPendingRows = Array.isArray(this.pendingGroup?.InvoiceRows) && this.pendingGroup.InvoiceRows.length > 0;

    if (this.isEditingWorkedHours) {
      return true;
    }

    return !this.workedHoursGroup && (hasPendingTitle || hasPendingRows);
  }

  hasPendingInlineEdits(): boolean {
    return this.hasPendingDescriptionDraft() || this.hasPendingWorkedHoursDraft();
  }

  canSaveJobPreNotification(): boolean {
    return (
      !this.isSaving &&
      !this.hasPendingInlineEdits() &&
      !!this.workedHoursGroup &&
      Array.isArray(this.invoice?.InvoiceGroups) &&
      this.invoice.InvoiceGroups.length > 0 &&
      this.hasSavedViewChanges()
    );
  }

  save(): void {
    if (this.hasPendingInlineEdits()) {
      this.showValidation('Spara eller avbryt p\u00e5g\u00e5ende redigering innan du sparar f\u00f6ranm\u00e4lan.');
      return;
    }

    if (!(this.invoice.Customer && this.invoice.Customer.Id)) {
      this.showValidation('V\u00e4lj en kund innan du sparar.');
      return;
    }

    if (!this.workedHoursGroup) {
      this.showValidation('L\u00e4gg till arbetad tid innan du sparar.');
      return;
    }

    if (!this.invoice.InvoiceGroups.length) {
      this.showValidation('L\u00e4gg till minst en beskrivning.');
      return;
    }

    this.showValidation('');
    this.isSaving = true;

    this.resetTemporaryIds();
    const payload = this.prepareInvoicePayload();
    const saveRequest =
      (this.editingInvoiceId && this.editingInvoiceId > 0) || (payload && payload.Id && payload.Id > 0)
        ? this.invoiceService.updateInvoice(payload, 'F\u00f6ranm\u00e4lan sparad!', undefined)
        : this.invoiceService.createInvoice(payload, 'F\u00f6ranm\u00e4lan sparad!', undefined);

    saveRequest.subscribe(
      response => {
        this.isSaving = false;
        if (response) {
          this.updateSavedViewSnapshot();
          this.openSnack('F\u00f6ranm\u00e4lan jobb sparad.');
          if (this.isAdmin) {
            this.router.navigate(['/mypages/invoices']);
          } else {
            this.router.navigate(['/job-calendar']);
          }
        } else {
          this.showValidation('Kunde inte spara f\u00f6ranm\u00e4lan. F\u00f6rs\u00f6k igen.');
        }
      },
      () => {
        this.isSaving = false;
        this.showValidation('Kunde inte spara f\u00f6ranm\u00e4lan. F\u00f6rs\u00f6k igen.');
      }
    );
  }

  private prepareInvoicePayload(): any {
    const payload = JSON.parse(JSON.stringify(this.invoice));
    payload.Type = { Name: payload.Type && payload.Type.Name ? payload.Type.Name : '', TechnicalName: SINGLE_INVOICE_TYPE };
    payload.InvoiceGroups = this.prepareInvoiceGroupsForSave(payload.InvoiceGroups || []);

    payload.TotalInvoiceAmount = this.totalAmount;
    payload.RecieverEmail = payload.RecieverEmail || payload.Customer.InvoiceEmail || '';
    payload.InvoiceSendMethodEmail = true;
    payload.InvoiceSendMethodMail = false;
    payload.Status = {
      TechnicalName: JOB_PRE_NOTIFICATION_STATUS,
      Name: JOB_PRE_NOTIFICATION_STATUS_NAME,
      Order: 0
    };
    payload.IsJobPreNotificationSave = true;
    payload.WorkNoticeStatus = { TechnicalName: WORK_NOTICE_STATUS_PRE_NOTIFIED };
    if (!payload.CustomerCopy || !payload.CustomerCopy.Id) {
      payload.CustomerCopy = JSON.parse(JSON.stringify(payload.Customer));
    }
    return payload;
  }

  private prepareInvoiceGroupsForSave(groups: any[]): any[] {
    if (!Array.isArray(groups) || groups.length === 0) {
      if (!this.workedHoursGroup) {
        return [];
      }
    }

    if (this.workedHoursGroup) {
      const descriptionGroups = (groups || []).map(group => {
        const preparedGroup = this.normalizeInvoiceGroupForSave(group);
        preparedGroup.Type = { TechnicalName: INVOICE_ITEM_GROUP_TYPE };
        preparedGroup.InvoiceRows = [];
        preparedGroup.WorkingTitle = '';
        return preparedGroup;
      });

      const timeGroup = this.normalizeInvoiceGroupForSave(this.workedHoursGroup);
      timeGroup.Type = { TechnicalName: WORKED_HOURS_GROUP_TYPE };
      timeGroup.Description = 'Arbetad tid';
      timeGroup.WorkingTitle = this.workedHoursGroup.WorkingTitle || '';
      timeGroup.InvoiceRows = (this.workedHoursGroup.InvoiceRows || []).map((row: any) => ({
        ...row,
        HoursWorked: (row.HoursWorked || '0').toString(),
        MinutesWorked: (row.MinutesWorked || '0').toString()
      }));

      return [...descriptionGroups, timeGroup];
    }

    const hasExplicitTypes = groups.some(group => group && group.Type && group.Type.TechnicalName);
    if (hasExplicitTypes) {
      return groups.map(group => this.normalizeInvoiceGroupForSave(group));
    }

    const descriptionGroups = groups.map(group => {
      const preparedGroup = this.normalizeInvoiceGroupForSave(group);
      preparedGroup.Type = { TechnicalName: INVOICE_ITEM_GROUP_TYPE };
      preparedGroup.InvoiceRows = [];
      preparedGroup.WorkingTitle = preparedGroup.WorkingTitle || '';
      return preparedGroup;
    });

    const timeSource = groups.find(group => group && (group.InvoiceRows && group.InvoiceRows.length)) || groups[0];
    const timeGroup = this.normalizeInvoiceGroupForSave(timeSource);
    timeGroup.Type = { TechnicalName: WORKED_HOURS_GROUP_TYPE };
    timeGroup.Description = 'Arbetad tid';
    timeGroup.WorkingTitle = timeGroup.WorkingTitle || '';
    timeGroup.InvoiceRows = groups
      .filter(group => group && Array.isArray(group.InvoiceRows))
      .flatMap(group => group.InvoiceRows)
      .map(row => ({
        ...row,
        HoursWorked: (row.HoursWorked || '0').toString(),
        MinutesWorked: (row.MinutesWorked || '0').toString()
      }));

    return [...descriptionGroups, timeGroup];
  }

  private normalizeInvoiceGroupForSave(group: any): any {
    const preparedGroup = { ...group };
    preparedGroup.Amount = Number(group.Amount) || 0;
    preparedGroup.Vat = group.Vat || group.VatNoSwe || '0';
    preparedGroup.InvoiceRows = (group.InvoiceRows || []).map((row: any) => ({
      ...row,
      HoursWorked: (row.HoursWorked || '0').toString(),
      MinutesWorked: (row.MinutesWorked || '0').toString()
    }));
    return preparedGroup;
  }

  private hasSavedViewChanges(): boolean {
    return this.createSavedViewSnapshot() !== this.savedViewSnapshot;
  }

  private hasUnsavedChanges(): boolean {
    return this.hasPendingInlineEdits() || this.hasSavedViewChanges();
  }

  private confirmNavigationIfNeeded(): boolean {
    if (!this.hasUnsavedChanges()) {
      return true;
    }

    return window.confirm('Vill du verkligen l\u00e4mna sidan? Osparade \u00e4ndringar kommer att g\u00e5 f\u00f6rlorade.');
  }

  private updateSavedViewSnapshot(): void {
    this.savedViewSnapshot = this.createSavedViewSnapshot();
  }

  private createSavedViewSnapshot(): string {
    return JSON.stringify(this.prepareInvoicePayload());
  }

  private resetTemporaryIds(): void {
    if (!this.invoice) {
      return;
    }

    if (this.workedHoursGroup) {
      if (!(typeof this.workedHoursGroup.Id === 'number' && this.workedHoursGroup.Id > 0)) {
        this.workedHoursGroup.Id = 0;
      }

      if (Array.isArray(this.workedHoursGroup.InvoiceRows)) {
        for (let i = 0; i < this.workedHoursGroup.InvoiceRows.length; i++) {
          if (!(typeof this.workedHoursGroup.InvoiceRows[i].Id === 'number' && this.workedHoursGroup.InvoiceRows[i].Id > 0)) {
            this.workedHoursGroup.InvoiceRows[i].Id = 0;
          }
        }
      }
    }

    if (Array.isArray(this.invoice.InvoiceGroups)) {
      for (let i = 0; i < this.invoice.InvoiceGroups.length; i++) {
        const group = this.invoice.InvoiceGroups[i];
        if (!(typeof group.Id === 'number' && group.Id > 0)) {
          group.Id = 0;
        }

        if (Array.isArray(group.InvoiceRows)) {
          for (let j = 0; j < group.InvoiceRows.length; j++) {
            if (!(typeof group.InvoiceRows[j].Id === 'number' && group.InvoiceRows[j].Id > 0)) {
              group.InvoiceRows[j].Id = 0;
            }
          }
        }
      }
    }

    if (Array.isArray(this.invoice.Deductions)) {
      for (let i = 0; i < this.invoice.Deductions.length; i++) {
        if (!(typeof this.invoice.Deductions[i].Id === 'number' && this.invoice.Deductions[i].Id > 0)) {
          this.invoice.Deductions[i].Id = 0;
        }
      }
    }

    if (Array.isArray(this.invoice.Allowances)) {
      for (let i = 0; i < this.invoice.Allowances.length; i++) {
        if (!(typeof this.invoice.Allowances[i].Id === 'number' && this.invoice.Allowances[i].Id > 0)) {
          this.invoice.Allowances[i].Id = 0;
        }
      }
    }
  }

  private openSnack(message: string): void {
    const config = new MatSnackBarConfig();
    config.duration = 4000;
    this.snackBar.open(message, undefined, config);
  }

  private showValidation(message: string): void {
    this.saveError = message;
  }

  canUpdateGeneral(): boolean {
    return true;
  }

  scrollToSection(sectionId: string): void {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  private guid(): string {
    return `${this.s4()}${this.s4()}-${this.s4()}-${this.s4()}-${this.s4()}-${this.s4()}${this.s4()}${this.s4()}`;
  }

  private s4(): string {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
}




